import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import ProductServices from './components/ProductServices';
import HowItWorks from './components/HowItWorks';
import CompetitiveAdvantages from './components/CompetitiveAdvantages';
import ProductCatalogSection from './components/ProductCatalogSection';
import ClientLogosCarousel from './components/ClientLogosCarousel';
import ContactForm from './components/ContactForm';
import ImageCarousel from './components/ImageCarousel';

function App() {
  return (
    <div className="App">
      <Navbar />
      <div id="hero-section">
        <HeroSection />
      </div>
      <div id="product-services">
        <ProductServices />
      </div>
      <div id="how-it-works">
        <HowItWorks />
      </div>
      <div id="product-catalog">
        <ProductCatalogSection />
      </div>
      <div id="competitive-advantages">
        <CompetitiveAdvantages />
      </div>
      <div id="image-carousel">
        <ImageCarousel />
      </div>
      <div id="client-logos">
        <ClientLogosCarousel />
      </div>
      <div id="contact">
        <ContactForm />
      </div>
      <Footer />
    </div>
  );
}

export default App;



